module.exports = __webpack_public_path__ + "img/Flag_of_Monaco.3d1d95bf.svg";